<template>
  <div>
    <div class="hero">
      <h1>Welcome to <span>Prime Fusion</span></h1>
      <p>Innovating the Future with Smart Solutions</p>
      <router-link to="/services" class="cta-button">Explore Our Services</router-link>
    </div>

    <!-- Yummable App Section -->
    <div class="yummable-section">
      <div class="yummable-content">
        <h2>Discover <span>Yummable</span></h2>
        <p>Yummable is an AI-powered recipe app that helps you explore dishes from around the world. With an interactive map, you can discover, cook, and share recipes from different cultures.</p>
        <router-link to="/yummable" class="yummable-button">Learn More</router-link>
      </div>
      <img src="@/assets/app.jpeg" alt="Yummable App" class="yummable-image" />
    </div>

    <!-- Screenshots Gallery -->
    <div class="screenshot-gallery">
      <h3>See Yummable in Action</h3>
      <div class="screenshot-scroll">
        <img v-for="n in 5" :key="n" :src="require(`@/assets/screen${n}.jpg`)" :alt="`Screenshot ${n}`" class="screenshot" />
      </div>
    </div>
  </div>
</template>

<style>
.yummable-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F9F9F9;
  padding: 60px 40px;
  border-radius: 12px;
  margin: 50px auto;
  max-width: 1200px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.yummable-content {
  max-width: 600px;
}

.yummable-section h2 {
  font-size: 36px;
  color: #333;
}

.yummable-section h2 span {
  color: #4A5D23;
}

.yummable-section p {
  font-size: 18px;
  color: #555;
  margin-top: 10px;
}

.yummable-button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 24px;
  background: #4A5D23;
  color: white;
  font-weight: bold;
  border-radius: 5px;
  text-decoration: none;
  font-size: 16px;
  transition: 0.3s;
}

.yummable-button:hover {
  background: #3A4D1A;
}

.yummable-image {
  width: 350px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.screenshot-gallery {
  max-width: 1200px;
  margin: 40px auto;
  padding: 20px 40px;
  text-align: center;
}

.screenshot-gallery h3 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

.screenshot-scroll {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding-bottom: 10px;
  scrollbar-width: thin;
}

.screenshot {
  flex: 0 0 auto;
  width: 220px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

</style>
